import TripScenarioAnswersModal from "components/bid/show/partials/tripScenarioAnswersModal";
import Loader from "components/shared/loader";
import { paths } from "helpers/paths";
import { columnName, formatValue, typeSpecificProps } from "helpers/reports";
import React from "react";
import { getBidTripScenario } from "sources/books/tripScenarios";
import CommonReport from "./commonReport";

class TripScenariosInfo extends TripScenarioAnswersModal {
    componentDidMount() {
        getBidTripScenario(this.props.id).then((data) => this.setState({ data, isLoading: false }));
    }

    render() {
        if (this.state.isLoading) {
            return <Loader />;
        }
        return (
            <div className="answer__list-card mb-3">
                <div className="card-body">
                    <div>{this.state.data.name}</div>
                    <div className="text-muted pb-3">{this.state.data.description}</div>
                    <table className="table table-sm">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Вопрос</th>
                                <th>Ответ</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.data.questions.map((question, i) => (
                                <tr key={question.id}>
                                    <td>{i + 1}</td>
                                    <td>{question.text}</td>
                                    <td>{this.renderAnswer(question, question.answer)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

export default class TripScenariosReport extends CommonReport {
    showScenario = (scenarioId) => {
        this.props.modal({
            name: "infoModal",
            windowMod: "wide",
            title: "Информация по опросу",
            body: <TripScenariosInfo id={scenarioId} />,
        });
    };

    cellProps = (column) => {
        return {
            Header: column.label,
            accessor: columnName(column),
            Cell: (props) => {
                const uniqueId = { [`data-${column.propertyName}`.toLowerCase()]: "" };
                switch (column.propertyName) {
                    case "BidTripScenarioId": {
                        return (
                            <div
                                className="link"
                                data-bid-trip-scenario-id={props.value}
                                onClick={this.showScenario.bind(this, props.value)}
                            >
                                {props.value}
                            </div>
                        );
                    }
                    case "BidId": {
                        return (
                            <a
                                data-bidid={props.value}
                                href={paths.bidShow("bid", props.value)}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {props.value}
                            </a>
                        );
                    }
                    default:
                        return (
                            <div className="long-text" {...uniqueId}>
                                {formatValue(props.value, column.clrType)}
                            </div>
                        );
                }
            },
            ...typeSpecificProps(column),
        };
    };

    tableExtraProps = () => ({ initialState: { hiddenColumns: ["userDriverId"] } });
}
